import { formatText } from '../../../../utils';
import type { DataValue } from '../../../types';
import type { NormalizedTweetType } from './formatTwitterResponse';

export const formatTwitterStatus = ({
  id,
  text,
  media: tweetMedia,
  created_at: createdAt,
  user: { verified, username, profile_image_url: profileImageUrl },
  public_metrics: { like_count: favoriteCount }
}: NormalizedTweetType): DataValue => {
  let media;

  const profileURL = `https://x.com/${username}/status/${id}`;

  if (tweetMedia.length) {
    const mediaItems = tweetMedia.map(
      ({
        type,
        url,
        preview_image_url: previewImage,
        is_preview_link: isPreviewLink
      }) => {
        // На данный момент, twitter api v2 не отдает ссылку на видео
        if (type === 'video') {
          return {
            type: 'link' as const,
            url: profileURL,
            title: '',
            description: '',
            src: previewImage,
            isPreviewLink
          };
        }

        return {
          type: 'image' as const,
          src: url,
          isPreviewLink
        };
      }
    );

    media =
      mediaItems.length > 1
        ? {
            type: 'gallery' as const,
            thumbnail: mediaItems[0].src,
            items: mediaItems
          }
        : mediaItems[0];
  }

  return {
    id,
    media,
    text: formatText(text, 'twitter'),
    timestamp: Date.parse(createdAt),
    source: {
      type: 'twitter',
      url: profileURL
    },
    user: {
      verified,
      name: username,
      image: profileImageUrl
        ? profileImageUrl.replace('_normal', '_reasonably_small')
        : undefined,
      url: profileURL
    },
    counters: {
      likes: favoriteCount,
      comments: 0
    }
  };
};
